<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal" class="flexContainer fd-c full t-fd-r t-fw-nw">
            <AdminTools></AdminTools>
            <section class="planosWrapper flexContainer jc-sb mobileNot">
                <section class="searchResultsWrapper size3of4 flexContainer fd-c tabletNot">
                    <section>
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb btnExp pointer" @click="createComponent();">{{ $t("componentType.create") }}</div>
                        </div>
                        <hr class="full mt10 separator" />
                        <transition-group name="fade" class="resultsWrapper flexContainer fw-w">
                            <div
                                v-for="n in componentTypeList"
                                :key="n.name"
                                v-if="n.active !== false"
                                class="listDisplay rel full flexContainer fd-c ai-c jc-fs"
                            >
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of5">
                                            <span class="listTitle uppercase center">{{ n.name }}</span>
                                        </div>
                                        <div class="fd-c size1of5">
                                            <span class="roundedIcon pointer" @click="editComponent(n.id);"> <i class="fas fa-pencil-alt"></i> </span>
                                            <span class="roundedIcon pointer" @click="deleteComponentType(n.id);">
                                                <i class="fas fa-trash-alt"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </section>
                </section>
            </section>
            <CreateComponentType v-if="newComponent" @hideCreateComponent="modalClose($event);"></CreateComponentType>
            <EditComponentType v-if="editComp" @hideEditComponent="modalClose2($event);"></EditComponentType>
        </section>
    </div>
</template>

<script>
import CreateComponentType from "../componentType/CreateComponentType.vue";
import EditComponentType from "../componentType/EditComponentType.vue";
import httpService from "../service";
import { mapActions } from "vuex";
import AdminTools from "../adminTools/Admin";
import { i18n } from "../../main.js";

export default {
    components: {
        CreateComponentType,
        EditComponentType,
        AdminTools
    },
    data: () => ({
        createStandDesign: false,
        componentTypeList: {},
        newComponent: false,
        editComp: false
    }),
    watch: {},
    methods: {
        ...mapActions({
            setComponentType: "items/setComponentType"
        }),
        modalClose(close) {
            this.newComponent = close;
        },
        modalClose2(close) {
            this.editComp = close;
        },
        showModal() {
            this.createStandDesign = true;
        },
        createComponent(a) {
            this.newComponent = true;
        },
        editComponent(id) {
            this.editComp = true;
            this.setComponentType(id);
        },
        deleteComponentType(id) {
            let self = this;
            let confirmTitle;
            let warningText;
            if (i18n.locale === "fr") {
                confirmTitle = "ERROR";
                warningText = "La suppression n'est pas autorisée car ce component type est déjà utilisée comme référence!";
            } else if (i18n.locale === "en") {
                confirmTitle = "ERROR";
                warningText = "Deletion is not allowed because it is being used as reference";
            }
            httpService.delete("/admin/components/types/" + id).then(function(response) {
                console.log("response", response);
                if (response !== "You can not deleted this item, it used") {
                    self.$swal({
                        html: "SUCCESS",
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "green",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "OK"
                    }).then(result => {
                        location.reload();
                    });
                } else {
                    self.$swal({
                        html: confirmTitle + "<br />" + warningText,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "red",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "OK"
                    }).then(result => {});
                }
            });
        }
    },
    computed: {},
    created() {
        // TODO: paginate instead of limit 1000
        httpService.get("/admin/components/types?limit=1000&").then(response => {
            this.componentTypeList = response.data;
        });
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ComponentList.vue?1f544185